module.exports = __webpack_public_path__ + "img/advantage2.65188337.png";